import { LoadParamsRequestOrError } from './LoadParamsRequestOrError.interface'
import {
  getProcessItemTypeConfig,
  PROCESS_ITEM_TYPE_TO_PARAMS_TYPE,
  ProcessItemConfigType,
  ProcessItemParamsType,
} from './processItemTypeConfig/getProcessItemTypeConfig'

export const getLoadParamsRequestOrError = <
  TType extends keyof PROCESS_ITEM_TYPE_TO_PARAMS_TYPE,
>(
  processItemParams: Partial<ProcessItemParamsType<TType>>,
  processItemType: TType,
): LoadParamsRequestOrError => {
  const processItemTypeConfig: ProcessItemConfigType<TType> =
    getProcessItemTypeConfig(processItemType)

  return processItemTypeConfig.getLoadParamsRequestOrError(processItemParams)
}
